import beard from '~/assets/icons/beard.svg';
import bodyHair from '~/assets/icons/body_hair.svg';
import brush from '~/assets/icons/brush.svg';
import eye from '~/assets/icons/eye_3.svg';
import eyeBrows from '~/assets/icons/eyebrows.svg';
import hair from '~/assets/icons/hair.svg';
import lipstick from '~/assets/icons/lipstick.svg';
import makeup from '~/assets/icons/makeup.svg';
import mask from '~/assets/icons/mask_2.svg';
import { BarberShopSection } from '~/shared';

export const CategoryNames = {
	[BarberShopSection.HAIR]: 'Прическа',
	[BarberShopSection.FACIAL_HAIR]: 'Борода',
	[BarberShopSection.EYEBROWS]: 'Брови',
	[BarberShopSection.BODY_HAIR]: 'Волосы на теле',
	[BarberShopSection.EYES]: 'Линзы',
	[BarberShopSection.BLUSH]: 'Румяна',
	[BarberShopSection.MAKEUP]: 'Макияж',
	[BarberShopSection.PAINT]: 'Раскраска',
	[BarberShopSection.LIPSTICK]: 'Помада',
};

export const CategoryImages = {
	[BarberShopSection.HAIR]: hair,
	[BarberShopSection.FACIAL_HAIR]: beard,
	[BarberShopSection.EYEBROWS]: eyeBrows,
	[BarberShopSection.BODY_HAIR]: bodyHair,
	[BarberShopSection.EYES]: eye,
	[BarberShopSection.BLUSH]: brush,
	[BarberShopSection.MAKEUP]: makeup,
	[BarberShopSection.PAINT]: mask,
	[BarberShopSection.LIPSTICK]: lipstick,
};

export interface ICategory {
	id: number;
	type: BarberShopSection;
	name: string;
	image: string;
}

export const categories: ICategory[] = [
	{
		id: 0,
		type: BarberShopSection.HAIR,
		name: CategoryNames[BarberShopSection.HAIR],
		image: CategoryImages[BarberShopSection.HAIR],
	},
	{
		id: 1,
		type: BarberShopSection.FACIAL_HAIR,
		name: CategoryNames[BarberShopSection.FACIAL_HAIR],
		image: CategoryImages[BarberShopSection.FACIAL_HAIR],
	},
	{
		id: 2,
		type: BarberShopSection.EYEBROWS,
		name: CategoryNames[BarberShopSection.EYEBROWS],
		image: CategoryImages[BarberShopSection.EYEBROWS],
	},
	{
		id: 3,
		type: BarberShopSection.BODY_HAIR,
		name: CategoryNames[BarberShopSection.BODY_HAIR],
		image: CategoryImages[BarberShopSection.BODY_HAIR],
	},
	{
		id: 4,
		type: BarberShopSection.EYES,
		name: CategoryNames[BarberShopSection.EYES],
		image: CategoryImages[BarberShopSection.EYES],
	},
	{
		id: 5,
		type: BarberShopSection.BLUSH,
		name: CategoryNames[BarberShopSection.BLUSH],
		image: CategoryImages[BarberShopSection.BLUSH],
	},
	{
		id: 6,
		type: BarberShopSection.MAKEUP,
		name: CategoryNames[BarberShopSection.MAKEUP],
		image: CategoryImages[BarberShopSection.MAKEUP],
	},
	{
		id: 7,
		type: BarberShopSection.PAINT,
		name: CategoryNames[BarberShopSection.PAINT],
		image: CategoryImages[BarberShopSection.PAINT],
	},
	{
		id: 8,
		type: BarberShopSection.LIPSTICK,
		name: CategoryNames[BarberShopSection.LIPSTICK],
		image: CategoryImages[BarberShopSection.LIPSTICK],
	},
];

export const getCategoryByType = (type: BarberShopSection | null) => {
	return categories.find((category) => category.type === type);
};
